export default "/images/check.svg?a2c24e5fc275003a079e8a6cf3868973";